module.exports = __webpack_public_path__ + "img/1800m.133ffeb2.png";